/* eslint-disable max-len */
import { ClientConfig } from '@1po/1po-bff-fe-spec/generated/config/response/ApplicationConfigResponse';
import { TFunction } from 'i18next';
import { EcosystemLink } from 'pages/MotrioEcosystemPage/EcosystemLinkCard/EcosystemLinkCard.types';

export const getEcosystemLinks = (t: TFunction, clientConfig?: ClientConfig): EcosystemLink[] => [
  {
    title: t('motrio_ecosystem.links.animations_r.title', 'Animations-R'),
    description: t(
      'motrio_ecosystem.links.animations_r.description',
      'Portal for tracking Renault sales promotions and challenges. It allows you to view results, prizes, and terms and conditions for participating in current promotions.',
    ),
    linkUrl: clientConfig?.animationsRLink,
    imageUrl: 'motrioEcosystem/animations-r.png',
    designStyle: 'S1',
    key: 0,
  },
  {
    title: t('motrio_ecosystem.links.motrio_marketing.title', 'Motrio Marketing Live'),
    description: t(
      'motrio_ecosystem.links.motrio_marketing.description',
      'Boost your workshop’s visibility with professional Motrio marketing materials.',
    ),
    linkUrl: clientConfig?.motrioMarketingLiveLink,
    imageUrl: 'motrioEcosystem/oil-motrio.png',
    designStyle: 'S2',
    key: 2,
  },
  {
    title: t('motrio_ecosystem.links.promo_motrio.title', 'Promo-motrio.com'),
    description: t(
      'motrio_ecosystem.links.promo_motrio.description',
      'Platform dedicated to MOTRIO internal promotions. It allows professionals to view commercial offers reserved for the network and submit invoices in order to benefit from financial participation from the MOTRIO brand.',
    ),
    linkUrl: clientConfig?.motrioPromoLink,
    imageUrl: 'motrioEcosystem/rain.png',
    designStyle: 'S4',
    key: 3,
  },
  {
    title: t('motrio_ecosystem.links.goodies_motrio.title', 'Goodies MOTRIO'),
    description: t(
      'motrio_ecosystem.links.goodies_motrio.description',
      'Discover a selection of items customized with Motrio colors.',
    ),
    linkUrl: clientConfig?.motrioGoodiesLink,
    imageUrl: 'motrioEcosystem/motrio-goodies.jpg',
    designStyle: 'S3',
    key: 4,
  },
  {
    title: t('motrio_ecosystem.links.concierge.title', 'Concierge Motrio'),
    description: t(
      'motrio_ecosystem.links.concierge.description',
      'Contact the Motrio concierge:\n Tel: 09 69 32 42 07\n conciergeriemotrio@contactclient.fr\n Monday to Friday: 9am-12:30pm  1:30pm-5:30pm',
    ),
    imageUrl: 'motrioEcosystem/notebook-guy.png',
    designStyle: 'S4',
    key: 14,
  },
  {
    title: t('motrio_ecosystem.links.workshop_hub.title', 'Workshop Hub'),
    description: t(
      'motrio_ecosystem.links.workshop_hub.description',
      'Easily manage and grow your online presence (hours, membership and online appointment management...)',
    ),
    buttonText: t('motrio_ecosystem.links.cta', 'CTA'),
    linkUrl: clientConfig?.workshopHubLink,
    imageUrl: 'motrioEcosystem/fill-oil.png',
    designStyle: 'S6',
    key: 15,
  },
  {
    title: t('motrio_ecosystem.links.allo_garage.title', 'Allo Garage'),
    description: t(
      'motrio_ecosystem.links.allo_garage.description',
      'Professional area of the AlloGarage.fr website. Allows garages to update their listings and respond to reviews.',
    ),
    buttonText: t('motrio_ecosystem.links.see_more', 'See more'),
    linkUrl: clientConfig?.alloGarageLink,
    imageUrl: 'motrioEcosystem/happy-guy.png',
    designStyle: 'S6',
    key: 5,
  },
  {
    title: t('motrio_ecosystem.links.partoo.title', 'PARTOO'),
    description: t(
      'motrio_ecosystem.links.partoo.description',
      'E-reputation management platform. Garages can manage their Google listing, respond to customer reviews, and improve their local online visibility.',
    ),
    linkUrl: clientConfig?.partooLink,
    imageUrl: 'motrioEcosystem/megaphone.jpg',
    designStyle: 'S1',
    key: 6,
  },
  {
    title: t('motrio_ecosystem.links.armis.title', 'ARMIS'),
    description: t(
      'motrio_ecosystem.links.armis.description',
      'Learn how to use the Armis Console marketing platform without needing to contact support for every question.',
    ),
    linkUrl: clientConfig?.armisLink,
    imageUrl: 'motrioEcosystem/team.jpg',
    designStyle: 'S4',
    key: 7,
  },
  {
    title: t('motrio_ecosystem.links.leaseway.title', 'Leaseway'),
    description: t(
      'motrio_ecosystem.links.leaseway.description',
      'Website of Leaseway, provider of mobility solutions (long-term vehicle rental) for garages.',
    ),
    linkUrl: clientConfig?.leasewayLink,
    imageUrl: 'motrioEcosystem/leaseway.png',
    designStyle: 'S4',
    key: 8,
  },
  {
    title: t('motrio_ecosystem.links.msa_interim.title', ' MSA Interim'),
    description: t(
      'motrio_ecosystem.links.msa_interim.description',
      'The number 1 platform for automotive professions!',
    ),
    linkUrl: clientConfig?.msaInterimLink,
    imageUrl: 'motrioEcosystem/msa.png',
    designStyle: 'S3',
    key: 9,
  },
  {
    title: t('motrio_ecosystem.links.ciscar.title', 'CISCAR'),
    description: t(
      'motrio_ecosystem.links.ciscar.description',
      'Purchasing center dedicated to automotive professionals. Provides access to preferential rates on equipment, tools, and consumables.',
    ),
    buttonText: t('motrio_ecosystem.links.see_more', 'See more'),
    linkUrl: clientConfig?.ciscarLink,
    imageUrl: 'motrioEcosystem/ciscar.png',
    designStyle: 'S6',
    key: 10,
  },
  {
    title: t('motrio_ecosystem.links.facom.title', 'FACOM'),
    description: t(
      'motrio_ecosystem.links.facom.description',
      'The benchmark in professional automotive tools. Robust products, storage solutions, and workshop organization.',
    ),
    buttonText: t('motrio_ecosystem.links.see_more', 'See more'),
    linkUrl: clientConfig?.facomLink,
    imageUrl: 'motrioEcosystem/facom.png',
    designStyle: 'S6',
    key: 11,
  },
  {
    title: t('motrio_ecosystem.links.sam.title', 'SAM'),
    description: t(
      'motrio_ecosystem.links.sam.description',
      'French manufacturer of professional hand tools and connected equipment for workshops. Manufacturer of hand tools and smart, connected storage solutions',
    ),
    buttonText: t('motrio_ecosystem.links.see_more', 'See more'),
    linkUrl: clientConfig?.samLink,
    imageUrl: 'motrioEcosystem/sam.png',
    designStyle: 'S6',
    key: 12,
  },
  {
    title: t('motrio_ecosystem.links.mobipolis.title', 'MOBIPOLIS (formerly GNFA)'),
    description: t(
      'motrio_ecosystem.links.mobipolis.description',
      'Automotive training organization (formerly GNFA). Offers continuous or work-study technical and commercial training tailored to the auto repair industry.',
    ),
    linkUrl: clientConfig?.mobipolisLink,
    imageUrl: 'motrioEcosystem/mobipolis.png',
    designStyle: 'S1',
    key: 13,
  },
];
